/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPieChart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m7.555 3.04.89 1.792A7.998 7.998 0 0 0 4 12a8 8 0 0 0 15.039 3.805l.13-.25 1.791.89A9.998 9.998 0 0 1 12 22C6.477 22 2 17.523 2 12a9.997 9.997 0 0 1 5.284-8.82zM12 2c5.523 0 10 4.477 10 10v1H11V2zm1 2.062V11h6.937l-.03-.226a8.006 8.006 0 0 0-6.681-6.68z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPieChart as PieChart };
